import { isRequestError } from "@prismicio/editor-support/Http"
import { ErrorBoundary, useAlert } from "@prismicio/editor-ui"
import type { PropsWithChildren } from "react"
import { useNavigate } from "react-router-dom"

function isDocumentNotFoundError(error: unknown): boolean {
  return (
    isRequestError(error) &&
    error.detail.type === "http" &&
    error.detail.status === 404
  )
}

export function DocumentNotFoundErrorBoundary(props: PropsWithChildren) {
  const { children } = props
  const navigate = useNavigate()
  const { showAlert } = useAlert()

  function onError(error: unknown) {
    if (!isDocumentNotFoundError(error)) {
      throw error
    }

    navigate("/", { replace: true })

    setTimeout(() => {
      showAlert({
        title: "Page not found",
        subtitle: `The page you are looking for does not exist anymore. You have been redirected to the working page list.`,
      })
    }, 250)
  }

  return <ErrorBoundary onError={onError}>{children}</ErrorBoundary>
}
